import { Condition } from '../dashboard/enums/condition.enum';

export const scoreToCondition = (score: number | null) => {
  if (score != null) {
    return score < 60 ? Condition.Poor : score < 80 ? Condition.Fair : Condition.Good;
  } else {
    return Condition.Disconnected;
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/score-to-condition.util.ts